import _ from "es-toolkit/compat";
import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { HTTP_404_NOT_FOUND } from "../../http";
import { baiFetch } from "../auth";
import type { VFolderHostListInfo, VirtualFolder } from "../backendai";

export const hostListInfoAtom = atom(async (get) => {
  const response = await baiFetch("/func/folders/_/hosts").then((res) =>
    res.json()
  );
  return response as VFolderHostListInfo;
});

export const folderAtom = atomFamily(
  ({ vFolderName }: { vFolderName: string }) =>
    atom(async (get) => {
      const response = await baiFetch(`/func/folders/${vFolderName}`).then(
        (res) => {
          if (res.status === HTTP_404_NOT_FOUND) {
            return null;
          }
          return res.json();
        }
      );
      return response as VirtualFolder;
    }),
  (a, b) => a.vFolderName === b.vFolderName
);
